import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import { Menu } from "@mui/material";
import React, { useRef } from "react";

import { CurrentChatInputMessages } from "@/messages/chat/current-chat-input.messages";
import NotificationItem from "@/mui/Items/NotificationItem";
import useToast from "@/contexts/toast-context";

interface MediaPopoverProps {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: CurrentChatInputMessages;
  onSelectFile: (file: File) => void;
}

export function MediaPopover({
  isOpen,
  anchorEl,
  onClose,
  messages,
  onSelectFile,
}: MediaPopoverProps) {
  const { mediaImageOrVideo, mediaDocument } = messages;
  const { showToast } = useToast();

  const imageVideoInputRef = useRef<HTMLInputElement>(null);
  const allMediaInputRef = useRef<HTMLInputElement>(null);

  const handleImageVideoSelection = () => {
    imageVideoInputRef.current?.click();
  };

  const handleAllMediaSelection = () => {
    allMediaInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const isVideo = file.type?.toLowerCase().startsWith("video");
      const maxBytes = 5 * 1024 * 1024; // 5 MB
      if (isVideo && file.size > maxBytes) {
        showToast({ text: "Vídeos de até 5 MB são permitidos.", type: "error" });
        return;
      }
      onSelectFile(file);
      onClose();
    }
  };

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      {/* Input para imagens e vídeos */}
      <input
        type="file"
        style={{ display: "none" }}
        ref={imageVideoInputRef}
        onChange={handleFileChange}
        accept="image/*,video/*"
      />
      {/* Input para todos os tipos de arquivos */}
      <input
        type="file"
        style={{ display: "none" }}
        ref={allMediaInputRef}
        onChange={handleFileChange}
      />
      <NotificationItem
        onClick={handleImageVideoSelection}
        icon={<ImageIcon />}
        title={mediaImageOrVideo}
      />
      <NotificationItem
        onClick={handleAllMediaSelection}
        icon={<DescriptionIcon />}
        title={mediaDocument}
      />
    </Menu>
  );
}
